import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent implements OnInit {
  @Input() message;
  @Output() eventOptionSelected = new EventEmitter();
  @ViewChild('dvElements') dvElements;

  showFlag: boolean = false;
  selectedImageIndex: number = -1;
  width: number = -1;
  height: number = -1;


  constructor(
    private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef) { }

  ngOnInit() { this.message.response = this.sanitizer.bypassSecurityTrustHtml(this.message.response);  }

  sendOption(opcion: string) {
    this.eventOptionSelected.emit(opcion);
     
    setTimeout(() => {
      this.message.options = [];
    }, 500);
  }

  getClasses() {
    if (this.message.autor == 'bot') {
      return 'd-flex flex-row justify-content-start chat-bot';
    }
    return 'd-flex flex-row justify-content-end chat-user';
  }

  ngAfterViewInit() {
    let elementsImg = this.dvElements.nativeElement.querySelectorAll('img');
    elementsImg.forEach((anchor: HTMLAnchorElement) => {
      anchor.addEventListener('click', this.openFullscreen);
    });
  }

  openFullscreen(element) {
    const elem = element.target;

    console.log(element);
   
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    }
  }

}
